import Typography from '../../typography/typography.component';
import Image, { StaticImageData } from 'next/image';
import {
    EntryPointCarListing1,
    EntryPointCarListing2,
    EntryPointCarListing3,
    EntryPointCarListing4,
    ChevronRightWhite,
} from '../../../../../public/Images';
import Button from '../../Button/button.component';
import { TFunction } from 'i18next';
import { openApp } from '@/utils';
import { useAnalytics } from '@/integrations';
import useAuth from '@/hook/use-auth.hook';
import myImageLoader from '@/image.local.loader';
import { SINGULAR_UNI_LINK_BANNERS } from '@/constants';

const AppEntryPointCarListingCard = ({
    img,
    title,
    text,
}: {
    img: StaticImageData;
    title: string;
    text?: string;
}) => {
    return (
        <div className="w-[156px] h-[244px] rounded-lg  flex flex-col overflow-hidden">
            <div className="h-[46%] overflow-hidden ">
                <img
                    alt="app-entry-point"
                    className="w-full h-full rounded-t-lg"
                    src={myImageLoader({
                        src: img.src,
                        width: 800,
                        height: 800,
                        quality: 100,
                    })}
                />
            </div>
            <div className="h-[54%] w-full bg-gray-50 flex flex-col p-3 items-center gap-1">
                <Typography
                    variant="body1SemiBold"
                    className="!text-gray-800 min-h-12 w-full"
                >
                    {title}
                </Typography>
                {text && (
                    <Typography variant="caption" className="!text-primary-700">
                        {text}
                    </Typography>
                )}
            </div>
        </div>
    );
};

const AppEntryPointCarListing = ({
    t,
}: {
    t: TFunction<'translation', undefined>;
}) => {
    const { trackEvent } = useAnalytics();
    const { userId, phone, email } = useAuth();

    return (
        <div className="border-y py-4 border-y-gray-200 w-screen en:-translate-x-[16px] ar:-translate-x-[-16px]">
            <div className="px-4 mb-3">
                <Typography
                    variant="subtitle2SemiBold"
                    className="!text-secondary-500"
                >
                    {t('whyDownloadApp')}
                </Typography>
            </div>
            <div className="overflow-y-scroll mb-4">
                <div className="px-4 flex gap-2 w-max">
                    <AppEntryPointCarListingCard
                        img={EntryPointCarListing1}
                        title={t('FinanceYourCar')}
                        text={t('ApplyForFinance')}
                    />
                    <AppEntryPointCarListingCard
                        img={EntryPointCarListing2}
                        title={t('trackYourBookings')}
                        text={t('stayUpdated')}
                    />
                    <AppEntryPointCarListingCard
                        img={EntryPointCarListing3}
                        title={t('BrowseCars')}
                        text={t('ScrollSmoothly')}
                    />
                    <AppEntryPointCarListingCard
                        img={EntryPointCarListing4}
                        title={t('AccessExclusive')}
                    />
                </div>
            </div>
            <div className="px-4">
                <Button
                    className="!h-11"
                    onClick={() => {
                        trackEvent('Click On Download App', {
                            userId,
                            sourceButton: 'Car Listing',
                            phone,
                            email,
                        });

                        openApp({ universalLink: SINGULAR_UNI_LINK_BANNERS });
                    }}
                >
                    <Typography variant="body2SemiBold" className="ar:mt-0.5">
                        {t('getApp')}
                    </Typography>
                    <Image
                        width={20}
                        className="en:mt-0.5 ar:rotate-180"
                        src={ChevronRightWhite}
                        alt="arrow-right"
                    />
                </Button>
            </div>
        </div>
    );
};

export default AppEntryPointCarListing;
